import {
  FeatureBlockContent,
  FeatureBlockSection
} from '../../FeatureBlockElements';
import HBText from "@honeybook-ui/HBText/HBText";
import TemplateGeneratorForm from '../../TemplateGenerator/TemplateGeneratorForm';
import { GeneratedTemplateType } from '../../../types/util-types';
import HBMediaElement from '../../honeybook-ui/HBMediaElement/HBMediaElement';
import './template-generator-hero-block.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  subtitle: string;
  templateType: GeneratedTemplateType;
}

const TemplateGeneratorHeroBlock = ({
  title,
  subtitle,
  templateType }: Props) => {
  const { t } = useTranslation();
  return (
    <FeatureBlockSection customClass="template-generator-hero-block">
      <FeatureBlockContent customClass="template-generator-hero-block__content">
        <HBText
          type="title-l"
          customClass="template-generator-hero-block__title"
        >
          {title}
        </HBText>
        <HBText
          type="body-s"
          customClass="template-generator-hero-block__subtitle"
        >
          {subtitle}
        </HBText>
        <TemplateGeneratorForm templateType={templateType}/>
        <div className="template-generator-hero-block__reviews-wrapper">
          <HBMediaElement name='marketing_site/ai_templates/Team_avatars.png' customClass='template-generator-hero-block__reviews-media'/>
          <HBText type="body-s" customClass="template-generator-hero-block__reviews-text">
            {t('templateGeneratorHeroBlock.reviews') as string}
          </HBText>
        </div>
      </FeatureBlockContent>
    </FeatureBlockSection>
  );
};

export default TemplateGeneratorHeroBlock;
